// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sg-login-dialog .el-dialog__header {\n  padding: 10px 12px;\n  background-color: #f2f4f5;\n  position: relative;\n}\n.sg-login-dialog .el-dialog__header .el-dialog__headerbtn {\n  top: 50%;\n  transform: translateY(-50%);\n}\n.sg-login-dialog .el-dialog__header .el-dialog__title {\n  color: #666;\n  font-size: 16px;\n}\n.sg-login-dialog .el-dialog__body {\n  padding-top: 0;\n}", ""]);
// Exports
module.exports = exports;
